import React from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";

const DashboardTabFilter = ({
  filters,
  onFilterChange,
  onApply,
  onClear,
  sourceLabel = "Source",
  sourceOptions = [
    { label: "All Sources", value: "All Sources" },
    { label: "Email Bar", value: "Email Bar" },
    { label: "Website Form", value: "Website Form" },
    { label: "Manual Test", value: "Manual Test" },
  ],
  showZipFilter = true,
  searchPlaceholder = "Search name, email...",
  singleLine = false,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "#FCF9F2",
        p: singleLine ? 2 : 3,
        borderRadius: "8px",
        border: "1px solid #EAE2D1",
        mb: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: singleLine ? 1.5 : 2,
          flexWrap: singleLine ? "nowrap" : "wrap",
          alignItems: singleLine ? "flex-end" : "stretch",
          overflowX: singleLine ? "auto" : "visible",
        }}
      >
        {/* Search */}
        <Box sx={{ flex: 1, minWidth: singleLine ? "160px" : "200px" }}>
          <Typography variant="caption">Search</Typography>

          <TextField
            fullWidth
            placeholder={searchPlaceholder}
            size="small"
            value={filters.search}
            onChange={(e) => onFilterChange("search", e.target.value)}
            sx={{ bgcolor: "#fff" }}
          />
        </Box>

        {/* Zip Code */}
        {showZipFilter && (
          <Box sx={{ flex: 1, minWidth: singleLine ? "130px" : "150px" }}>
            <Typography variant="caption">Zip Code</Typography>

            <TextField
              fullWidth
              placeholder="Enter ZIP code"
              size="small"
              value={filters.zip_code}
              slotProps={{ htmlInput: { maxLength: 6 } }}
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, "");
                onFilterChange("zip_code", value);
              }}
              sx={{ bgcolor: "#fff" }}
            />
          </Box>
        )}

        {/* Dynamic Source/Interest Filter */}
        <Box sx={{ flex: 1, minWidth: singleLine ? "130px" : "150px" }}>
          <Typography variant="caption">{sourceLabel}</Typography>

          <Select
            fullWidth
            size="small"
            value={filters.source}
            onChange={(e) => onFilterChange("source", e.target.value)}
            sx={{ bgcolor: "#fff" }}
          >
            {sourceOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>

        {/* From Date */}
        <Box sx={{ flex: 1, minWidth: singleLine ? "130px" : "150px" }}>
          <Typography variant="caption">From Date</Typography>

          <TextField
            fullWidth
            type="date"
            size="small"
            value={filters.from_date}
            onChange={(e) => onFilterChange("from_date", e.target.value)}
            sx={{ bgcolor: "#fff" }}
          />
        </Box>

        {/* To Date */}
        <Box sx={{ flex: 1, minWidth: singleLine ? "130px" : "150px" }}>
          <Typography variant="caption">To Date</Typography>

          <TextField
            fullWidth
            type="date"
            size="small"
            value={filters.to_date}
            onChange={(e) => onFilterChange("to_date", e.target.value)}
            sx={{ bgcolor: "#fff" }}
          />
        </Box>

        {singleLine && (
          <Stack
            direction="row"
            spacing={1}
            sx={{ flexShrink: 0, alignItems: "center" }}
          >
            <Button
              variant="contained"
              onClick={onApply}
              size="small"
              sx={{
                bgcolor: "#0F1E3D",
                textTransform: "none",
                fontWeight: 700,
                whiteSpace: "nowrap",
                height: 40,
                px: 2,
                "&:hover": { bgcolor: "#1a2e5a" },
              }}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              onClick={onClear}
              size="small"
              sx={{
                color: "#666",
                borderColor: "#ddd",
                textTransform: "none",
                bgcolor: "#EAEAEA",
                whiteSpace: "nowrap",
                height: 40,
                px: 2,
                "&:hover": { bgcolor: "#ddd", borderColor: "#ccc" },
              }}
            >
              Clear
            </Button>
          </Stack>
        )}
      </Box>

      {/* Buttons (stacked below in normal mode) */}
      {!singleLine && (
      <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
        <Button
          variant="contained"
          onClick={onApply}
          sx={{
            bgcolor: "#0F1E3D",
            textTransform: "none",
            fontWeight: 700,
            "&:hover": {
              bgcolor: "#1a2e5a",
            },
          }}
        >
          Apply Filters
        </Button>

        <Button
          variant="outlined"
          onClick={onClear}
          sx={{
            color: "#666",
            borderColor: "#ddd",
            textTransform: "none",
            bgcolor: "#EAEAEA",
            "&:hover": {
              bgcolor: "#ddd",
              borderColor: "#ccc",
            },
          }}
        >
          Clear All
        </Button>
      </Stack>
      )}
    </Box>
  );
};

export default DashboardTabFilter;
